<app-loader [show]="isLoading"></app-loader>
<div class="roster-list-component-container page-root-container page-list-component-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/roster.svg" *ngIf="!dialogRef">
            <span class="title">{{ dialogRef ? 'Select Roster' : 'Roster List' }}</span>
        </div>
        <div class="page-actions">
            <button mat-button color="primary" class="btn-add" (click)="addClicked()" *ngIf="!dialogRef">
                <mat-icon>add</mat-icon>New Roster
            </button>
            <button mat-icon-button *ngIf="dialogRef" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="data-container">

        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="dataSource">
                <!-- ... existing columns ... -->
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef style="width: 50px;">#</th>
                    <td mat-cell *matCellDef="let row; let i = index" style="cursor: pointer;">
                        {{ i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                    <th mat-sort-header="start_date" mat-header-cell *matHeaderCellDef>From Date</th>
                    <td mat-cell *matCellDef="let row" style="cursor: pointer;">
                        {{row.start_date | date:'dd MMM yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                    <th mat-sort-header="end_date" mat-header-cell *matHeaderCellDef>To Date</th>
                    <td mat-cell *matCellDef="let row" style="cursor: pointer;">
                        {{row.end_date | date:'dd MMM yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="weekNumber">
                    <th mat-sort-header="week_number" mat-header-cell *matHeaderCellDef>Week</th>
                    <td mat-cell *matCellDef="let row" style="cursor: pointer;">{{row.week_number}}</td>
                </ng-container>

                <ng-container matColumnDef="year">
                    <th mat-sort-header="year" mat-header-cell *matHeaderCellDef>Year</th>
                    <td mat-cell *matCellDef="let row" style="cursor: pointer;">{{row.display_year || row.year}}</td>
                </ng-container>



                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">

                            <button mat-menu-item (click)="onClone(row)">
                                <mat-icon>content_copy</mat-icon>
                                <span>Clone</span>
                            </button>
                            <button mat-menu-item (click)="onEdit(row)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="onDelete(row)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let row; columns: displayedColumns;" (click)="onEdit(row)"
                    style="cursor: pointer;"></tr>
            </table>
        </section>
    </div>
</div>